import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import __map from 'lodash/map';
import OutsideClickHandler from 'react-outside-click-handler';
import { BeginGlobalHeader } from '@learnwithhomer/begin-component-library';


import './Header.scss';
import Collapsible from '../Collapsible';
import PostListItem from '../PostListItem';
import butter from '../../services/butter-client';
import { useGetReferrerParams, useSubscribeToBeginHeaderEvents } from './hooks';

Modal.setAppElement('#root');

const foosPage = process.env.REACT_APP_CODESPARK_BASE_URL;
const accountsPage = process.env.REACT_APP_ACCOUNTS_BASE_URL;
const dashboardPage = process.env.REACT_APP_DASHBOARD_BASE_URL;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isMenuOpen: false,
      openMobileOption: '',
      isSearchModalOpen: false,
      searchedPostsAtEnd: false,
      searchedPosts: [],
      openParentsMenu: false,
      openEducatorsMenu: false,
      openAboutMenu: false,
      openMobileMenu: false,
    };

    this.prepareToSearch = this.prepareToSearch.bind(this);
    this.prepareToCloseModal = this.prepareToCloseModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      openParentsMenu: false,
      openEducatorsMenu: false,
      openAboutMenu: false,
      openMobileMenu: false,
    });
  }

  toggleParents = () => {
    this.setState({ openParentsMenu: !this.state.openParentsMenu });
  };

  toggleEducators = () => {
    this.setState({ openEducatorsMenu: !this.state.openEducatorsMenu });
  };

  toggleAbout = () => {
    this.setState({ openAboutMenu: !this.state.openAboutMenu });
  };

  prepareToSearch() {
    setTimeout(() => {
      document.querySelector('.search-overlay').classList.add('fade-in');
      document.querySelector('body').style.overflowY = 'hidden';
    }, 0);

    const searchInput = document.querySelector('input[name="search"]');
    const clearButton = document.querySelector('.text-clear-button');
    if (searchInput !== null) {
      searchInput.addEventListener('keyup', (e) => {
        if (searchInput.value.length > 0) {
          if (clearButton.classList.contains('hide')) {
            clearButton.classList.remove('hide');
          }
        } else {
          clearButton.classList.add('hide');
          this.setState({ searchedPosts: [] });
        }
      });

      clearButton.addEventListener('click', (e) => {
        searchInput.value = '';
        clearButton.classList.add('hide');
        this.setState({ searchedPosts: [] });
        document.querySelector('.search-modal').classList.remove('background-on');
      });
    }
  }

  // TODO - what does butter use to search against?
  searchPosts(value) {
    if (value === '' || value.length < 3) {
      return;
    }

    butter.post
      .search(value, { page: 1, page_size: 10 })
      .then((results) => {
        const posts = results.data.data.length > 0 ? results.data.data : null;
        this.setState({ searchedPosts: posts });
        document.querySelector('.search-modal').classList.add('background-on');
      })
      .catch((error) => {
        console.log(error);
      });
  }

  prepareToCloseModal() {
    this.setState(
      {
        searchedPosts: [],
        searchedPostsAtEnd: false,
        isSearchModalOpen: false,
      },
      () => {
        document.querySelector('input[name="search"]').value = '';
        document.querySelector('body').style.overflowY = 'auto';
      }
    );
  }

  goToLink(link) {
    window.open(link, '_blank');
  }

  render() {
    const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;
    const { openParentsMenu, openEducatorsMenu, openAboutMenu, openMobileMenu } = this.state;

    return (
      <div className="header-wrapper">
        <div className={`global-header-wrapper full-width ${this.props.isScrolling ? 'scrolling' : ''}`}>
          <BeginGlobalHeader activeBrand="codespark" activeHref="https://codespark.com" urlParams={this.props.referrerParams} />
          <div className="header-top-container">
            <div className="header-navigation">
              <div className="navigation-menu">
                <button name="parents" className="header-link" onClick={this.toggleParents}>
                  Parents
                  <img
                    className={openParentsMenu ? 'flipped-arrow dropdown-arrow' : 'dropdown-arrow'}
                    src={`${imgURL}/global/icons/single_arrow.svg`}
                    alt="down arrow"
                  />
                </button>
                {openParentsMenu ? (
                  <OutsideClickHandler onOutsideClick={this.toggleParents}>
                    <ul className="menu-dropdown">
                      <li className="menu-link">
                        <a href={`${foosPage}/how-it-works`}>How it Works</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${foosPage}/frequently-asked-questions`}>FAQ</a>
                      </li>
                      <li className="menu-link">
                        <a href={process.env.REACT_APP_SIGNUP_BASE_URL}>Free Trial</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${accountsPage}/gift`}>Buy a Gift</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${accountsPage}/promo`}>Redeem a Gift</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${accountsPage}/login`}>Login</a>
                      </li>
                    </ul>
                  </OutsideClickHandler>
                ) : null}
              </div>
              <div className="navigation-menu">
                <button className="header-link" onClick={this.toggleEducators}>
                  Educators
                  <img
                    className={openEducatorsMenu ? 'flipped-arrow dropdown-arrow' : 'dropdown-arrow'}
                    src={`${imgURL}/global/icons/single_arrow.svg`}
                    alt="down arrow"
                  />
                </button>
                {openEducatorsMenu ? (
                  <OutsideClickHandler onOutsideClick={this.toggleEducators}>
                    <ul className="menu-dropdown educators">
                      <li className="menu-link">
                        <a href={`${foosPage}/educators`}>Resources</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${foosPage}/hour-of-code`}>Hour of Code</a>
                      </li>
                      <li className="menu-link">
                        <a href={dashboardPage}>Teacher Dashboard</a>
                      </li>
                      <li className="menu-link">
                        <a href="https://teach.codespark.com/courses/codespark-ignite">Professional Development</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${foosPage}/play`}>Play Online</a>
                      </li>
                    </ul>
                  </OutsideClickHandler>
                ) : null}
              </div>
              <div className="navigation-menu">
                <button className="header-link" onClick={this.toggleAbout}>
                  About
                  <img
                    className={openAboutMenu ? 'flipped-arrow dropdown-arrow' : 'dropdown-arrow'}
                    src={`${imgURL}/global/icons/single_arrow.svg`}
                    alt="down arrow"
                  />
                </button>
                {openAboutMenu ? (
                  <OutsideClickHandler onOutsideClick={this.toggleAbout}>
                    <ul className="menu-dropdown about">
                      <li className="menu-link">
                        <a href={`${foosPage}/about`}>About Us</a>
                      </li>
                      <li className="menu-link">
                        <a href="/posts/codespark-academy-award-winning-coding-app">Awards</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${foosPage}/press`}>Press</a>
                      </li>
                      <li className="menu-link">
                        <a href={`${foosPage}/contact`}>Contact Us</a>
                      </li>
                    </ul>
                  </OutsideClickHandler>
                ) : null}
              </div>
            </div>
            <div className="logo">
              <a href={process.env.REACT_APP_CODESPARK_BASE_URL}>
                <img src={`${imgURL}/global/logo/codesparkAcademy.svg`} alt="codeSpark Academy" />
              </a>
            </div>
            <div className="search-icon" onClick={() => this.setState({ isSearchModalOpen: true })}>
              <i className="fa fa-search"></i>
            </div>
            <div className="cta-button">
              <button onClick={() => this.goToLink(accountsPage)}>7 day FREE Trial</button>
            </div>
          </div>
        </div>

        {/* MOBILE MENU */}
        <div className="mobile-menu-wrapper">
          <div className="grid-x grid-padding-x align-middle">
            <div className="logo small-6">
              <a href={process.env.REACT_APP_CODESPARK_BASE_URL}>
                <img src={`${imgURL}/global/logo/codesparkAcademy.svg`} alt="codeSpark Academy" />
              </a>
            </div>
            <div className="hamburger-menu small-6">
              {openMobileMenu ? (
                <i
                  className="fa fa-times"
                  aria-hidden="true"
                  onClick={() => this.setState({ openMobileMenu: false })}
                />
              ) : (
                <i className="fa fa-bars" aria-hidden="true" onClick={() => this.setState({ openMobileMenu: true })} />
              )}
            </div>
          </div>
          {openMobileMenu && (
            <div className="mobile-menu-open">
              <div className="mobile-navigation-menu parents">
                <Collapsible
                  trigger="Parents"
                  transitionTime={250}
                  easing="ease"
                  open={openParentsMenu}
                  handleTriggerClick={openParentsMenu}
                >
                  <ul className="menu-collapsible--menu-items">
                    <li className="menu-link">
                      <a href={`${foosPage}/how-it-works`}>How it Works</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${foosPage}/frequently-asked-questions`}>FAQ</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${process.env.REACT_APP_SIGNUP_BASE_URL}`}>Free Trial</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${accountsPage}/gift`}>Buy a Gift</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${accountsPage}/promo`}>Redeem a Gift</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${accountsPage}/login`}>Login</a>
                    </li>
                  </ul>
                </Collapsible>
              </div>
              <div className="mobile-navigation-menu">
                <Collapsible
                  trigger="Educators"
                  transitionTime={250}
                  easing="ease"
                  open={openEducatorsMenu}
                  handleTriggerClick={openEducatorsMenu}
                >
                  <ul className="menu-collapsible--menu-items educators">
                    <li className="menu-link">
                      <a href={`${foosPage}/educators`}>Resources</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${foosPage}/hour-of-code`}>Hour of Code</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${dashboardPage}`}>Teacher Dashboard</a>
                    </li>
                    <li className="menu-link">
                      <a href="https://teach.codespark.com/courses/codespark-ignite">Professional Development</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${foosPage}/play`}>Play Online</a>
                    </li>
                  </ul>
                </Collapsible>
              </div>
              <div className="mobile-navigation-menu">
                <Collapsible
                  trigger="About"
                  transitionTime={250}
                  easing="ease"
                  open={openAboutMenu}
                  handleTriggerClick={openAboutMenu}
                >
                  <ul className="menu-collapsible--menu-items about">
                    <li className="menu-link">
                      <a href={`${foosPage}/about`}>About Us</a>
                    </li>
                    <li className="menu-link">
                      <a href="/posts/codespark-academy-award-winning-coding-app">Awards</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${foosPage}/press`}>Press</a>
                    </li>
                    <li className="menu-link">
                      <a href={`${foosPage}/contact`}>Contact Us</a>
                    </li>
                  </ul>
                </Collapsible>
              </div>
            </div>
          )}
        </div>
        <Modal
          isOpen={this.state.isSearchModalOpen}
          onAfterOpen={this.prepareToSearch}
          onRequestClose={this.prepareToCloseModal}
          shouldCloseOnOverlayClick={true}
          contentLabel="Search keywords for blog results"
          overlayClassName="search-overlay"
          className="search-modal"
        >
          <div className="search-wrapper">
            <div className="search-form">
              <input
                type="text"
                placeholder="Search"
                name="search"
                onChange={(e) => this.searchPosts(e.target.value)}
              />
              <button className="text-clear-button hide">
                <i className="fa fa-times-circle"></i>
              </button>
            </div>
            <div className="search-results">
              {this.state.searchedPosts === null ? (
                <div className="no-results-container">
                  <img alt="" src={`${imgURL}/blog/woz_confused.gif`} />
                  <p className="no-results-title">Sorry, dunno whatcha lookin' for...</p>
                  <p className="no-results-subtitle">Please try your search again.</p>
                </div>
              ) : (
                <div className="result-container">
                  {__map(this.state.searchedPosts, (post, i) => {
                    return <PostListItem key={i} layout="eighth" post={post} onClick={this.prepareToCloseModal} />;
                  })}
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

Header.propTypes = {
  isScrolling: PropTypes.bool,
};

const HeaderWithHooks = (props) => {
  useSubscribeToBeginHeaderEvents();
  const referrerParams = useGetReferrerParams();
  return <Header {...props} referrerParams={referrerParams} />
}

export default HeaderWithHooks;
